function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Colors from styleguide (decided to leave names even if they are not following any convention)
var lightGray = '#f8f8f8';
var midGray = '#a3a7b1';
var darkGray = '#646972';
var blueA50 = '#d4f0fa';
var blueA15 = '#f3fbfe';
var blueA30 = '#E3E5EA';
var greenB = '#cce6d8';
var greenC = '#02803A';
var yellowA = '#fef4cd';

// Convention is to use alphabet letters for new colors.
// like green, greenA, greenB
// And use functions to make them lighter or darker
var white = '#fff';
var black = '#000';
var gray = '#c8ccd6';
var grayA = '#b1b3b8';
var yellow = '#fcc605';
var orange = '#d99300';
var green = '#33b91e';
var greenA = '#009f47';
var red = '#d61c1c';
var redA = '#FCDDE0';
var blueA = '#ace1f4';
var blueB = '#31b6e4';
var blueC = '#1576c9';
var blueD = '#005ca9';
var blueE = '#19335e';

// BRAND colors
// Primary colors
var blue1 = '#005fbe';
var blue2 = '#002c4E';
// Accent colors
var yellowB = '#ffac00';
var purple = '#bcb3fc';
var blueS = '#9ad7f9';
// Secondary colors
var gray1 = '#f2f4f8';
var gray2 = '#c1c7cd';
var gray3 = '#697077';
var gray4 = '#c4c4c4';
var redB = '#ed2939';
var redC = '#d00000';
var redD = '#AE1C28';
var yellowC = '#fae042';
var yellowD = '#ffce00';
var blue3 = '#002395';
var blue4 = '#21468B';
export default {
  white: white,
  lightGray: lightGray,
  gray: gray,
  midGray: midGray,
  darkGray: darkGray,
  black: black,
  yellow: yellow,
  yellowA: yellowA,
  orange: orange,
  green: green,
  greenB: greenB,
  greenC: greenC,
  red: red,
  redA: redA,
  blueA: blueA,
  blueA50: blueA50,
  blueA15: blueA15,
  blueA30: blueA30,
  blueB: blueB,
  blueC: blueC,
  blueD: blueD,
  blueE: blueE,
  blue1: blue1,
  blue2: blue2,
  yellowB: yellowB,
  purple: purple,
  blueS: blueS,
  gray1: gray1,
  gray2: gray2,
  gray3: gray3,
  gray4: gray4,
  redB: redB,
  redC: redC,
  redD: redD,
  yellowC: yellowC,
  yellowD: yellowD,
  blue3: blue3,
  blue4: blue4
};
export var grays = {
  white: white,
  lightGray: lightGray,
  gray: gray,
  midGray: midGray,
  darkGray: darkGray,
  black: black
};
export var signal = {
  warning: orange,
  success: green,
  alert: red,
  unavailable: gray,
  loading: blueD,
  info: blueB
};
export var heading = {
  primary: blueD,
  secondary: black,
  complementary: blueB,
  inverted: white,
  cta: yellow
};
export var text = _objectSpread(_objectSpread(_objectSpread({}, grays), signal), {}, {
  primary: black,
  inverted: white,
  secondary: blueD,
  complementary: midGray,
  additional: blueB,
  cta: yellow,
  ghost: blueC,
  tertiary: blueE,
  proceed: greenA
});
export var background = _objectSpread(_objectSpread(_objectSpread({}, grays), signal), {}, {
  primary: blueD,
  lightPrimary: blueC,
  secondary: blueA15,
  tertiary: blueA50,
  alert: redA,
  cta: yellow
});
export var shadow = {
  blue: blueA30
};
export var button = _objectSpread(_objectSpread({}, grays), {}, {
  primary: blueD,
  tertiary: blueE,
  proceed: greenA,
  cta: yellow
});
export var border = _objectSpread(_objectSpread(_objectSpread({}, grays), signal), {}, {
  tertiary: blueE,
  proceed: greenA,
  primary: blueD,
  lightPrimary: blueC
});
export var link = {
  primary: blueD
};
export var logo = {
  primary: blueD,
  inverted: white
};
export var divider = {
  primary: gray,
  secondary: blueD
};
export var overlay = {
  dim: grayA
};
export var fill = {
  primary: black,
  inverted: white
};